var exports = {
  "wm": "x112a1f60--2e229b--logo",
  "yr": "x112a1f60--2e229b--logo-image",
  "_j": "x112a1f60--2e229b--logo-default",
  "Gp": "x112a1f60--2e229b--logo-default-content",
};

module.exports = exports;
